<div class="hero-content">
  <h1 class="hero-title">{{ title }}</h1>

  <div class="dashboard-illustration">
    <!-- Main Dashboard Window -->
    <div class="dashboard-window dash-main">
      <div class="window-header dark">
        <span class="dot red"></span>
        <span class="dot yellow"></span>
        <span class="dot green"></span>
      </div>
      <div class="window-body">
        <div class="widget">
          <div class="widget-header">
            <div class="widget-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
            </div>
          </div>
          <div class="widget-lines">
            <div class="line long"></div>
            <div class="line medium"></div>
            <div class="line short"></div>
          </div>
        </div>

        <div class="widget widget-circle">
          <div class="circle-progress">
            <svg width="60" height="60" viewBox="0 0 60 60">
              <defs>
                <linearGradient id="heroGradient1A" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style="stop-color:#3a8ba8" />
                  <stop offset="100%" style="stop-color:#5ab4c4" />
                </linearGradient>
                <linearGradient id="heroGradient2A" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style="stop-color:#1a4a5a" />
                  <stop offset="100%" style="stop-color:#3a8ba8" />
                </linearGradient>
              </defs>
              <circle class="circle-bg" cx="30" cy="30" r="25" />
              <circle
                class="circle-fill"
                cx="30"
                cy="30"
                r="25"
                stroke="url(#heroGradient1A)"
              />
            </svg>
          </div>
          <div style="margin-left: 12px;">
            <div class="line medium" style="width: 80px;"></div>
            <div class="line short" style="width: 50px; margin-top: 6px;"></div>
          </div>
        </div>

        <div class="widget">
          <div class="widget-header">
            <div class="widget-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
            </div>
          </div>
          <div class="widget-lines">
            <div class="line long"></div>
            <div class="line medium"></div>
          </div>
        </div>

        <div class="widget widget-circle">
          <div class="circle-progress">
            <svg width="60" height="60" viewBox="0 0 60 60">
              <defs>
                <linearGradient id="heroGradient1B" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style="stop-color:#3a8ba8" />
                  <stop offset="100%" style="stop-color:#5ab4c4" />
                </linearGradient>
                <linearGradient id="heroGradient2B" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style="stop-color:#1a4a5a" />
                  <stop offset="100%" style="stop-color:#3a8ba8" />
                </linearGradient>
              </defs>
              <circle class="circle-bg" cx="30" cy="30" r="25" />
              <circle
                class="circle-fill-2"
                cx="30"
                cy="30"
                r="25"
                stroke="url(#heroGradient2B)"
              />
            </svg>
          </div>
          <div style="margin-left: 12px;">
            <div class="line medium" style="width: 80px;"></div>
            <div class="line short" style="width: 50px; margin-top: 6px;"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Floating Window 1 -->
    <div class="dashboard-window dash-float-1">
      <div class="window-header">
        <span class="dot red"></span>
        <span class="dot yellow"></span>
        <span class="dot green"></span>
      </div>
      <div class="window-body">
        <div class="avatar-circle">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
            />
          </svg>
        </div>
        <div class="mini-lines">
          <div class="line long"></div>
          <div class="line medium"></div>
        </div>
        <div class="bar-chart">
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </div>
      </div>
    </div>

    <!-- Floating Window 2 -->
    <div class="dashboard-window dash-float-2">
      <div class="window-header">
        <span class="dot red"></span>
        <span class="dot yellow"></span>
        <span class="dot green"></span>
      </div>
      <div class="window-body">
        <div class="line-chart">
          <svg viewBox="0 0 180 80" preserveAspectRatio="none">
            <defs>
              <linearGradient id="lineGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" style="stop-color:#3a8ba8;stop-opacity:0.2" />
                <stop offset="100%" style="stop-color:#3a8ba8;stop-opacity:0" />
              </linearGradient>
            </defs>
            <path
              d="M0,60 Q20,55 30,50 T60,45 T90,35 T120,40 T150,25 T180,30"
              fill="none"
              stroke="#3a8ba8"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M0,60 Q20,55 30,50 T60,45 T90,35 T120,40 T150,25 T180,30 L180,80 L0,80 Z"
              fill="url(#lineGrad)"
            />
            <circle cx="30" cy="50" r="3" fill="#3a8ba8" />
            <circle cx="60" cy="45" r="3" fill="#3a8ba8" />
            <circle cx="90" cy="35" r="3" fill="#3a8ba8" />
            <circle cx="120" cy="40" r="3" fill="#3a8ba8" />
            <circle cx="150" cy="25" r="3" fill="#3a8ba8" />
          </svg>
        </div>
        <div style="display: flex; gap: 8px; margin-top: 8px;">
          <div class="line" style="width: 30px; height: 3px; background: #3a8ba8;"></div>
          <div class="line" style="width: 30px; height: 3px; background: #a0d0dc;"></div>
          <div class="line" style="width: 30px; height: 3px; background: #d0e8ee;"></div>
        </div>
      </div>
    </div>
  </div>

  <p class="hero-footer">{{ footer }}</p>
</div>
